import { TFunction } from "i18next";
import InternalStripe from "stripe";
import { formatCurrency } from "../../../utils/formatCurrency";

export const getPlanOfferText = (plan: InternalStripe.Plan, t: TFunction) => {
  const product = plan.product as InternalStripe.Product;
  const trialDays = plan.trial_period_days;

  if (trialDays) {
    // 1 dag
    if (trialDays === 1) {
      return t("offers.oneDay");
    }

    // 1 vecka
    if (trialDays === 7) {
      return t("offers.oneWeek");
    }
    // 1 + N veckor
    if (trialDays % 7 === 0) {
      return t("offers.xWeeks", { weeks: trialDays / 7 });
    }

    // 1 + N dagar
    return t("offers.xDays", { days: trialDays });
  }

  return product.name;
};

export const getPlanPriceText = (plan: InternalStripe.Plan) => {
  const amount = formatCurrency(plan.amount / 100, plan.currency);
  return { amount, interval: "/" + plan.interval };
};

export const getCampaignPriceText = (plan: InternalStripe.Plan) => {
  let amount: string;
  const subAmount = plan["activeCampaign"]["amount_off"];
  const subPercent = plan["activeCampaign"]["percent_off"];

  amount = subAmount
    ? formatCurrency((plan.amount - subAmount) / 100, plan.currency)
    : formatCurrency(
        (plan.amount - plan.amount * (subPercent * 0.01)) / 100,
        plan.currency
      );

  const price = `${amount}/${plan.interval}`;

  return price;
};

export const getTrialPeriodDurationText = (
  plan: InternalStripe.Plan,
  t: TFunction
): string | null => {
  const trialDays = plan.trial_period_days;

  if (!trialDays) {
    return null;
  }

  // 1 day
  if (trialDays === 1) {
    return t("duration.oneDay");
  }

  // 1 week
  if (trialDays === 7) {
    return t("duration.oneWeek");
  }

  // 1 + N weeks
  if (trialDays % 7 === 0) {
    return `${trialDays / 7} ${t("duration.xWeeks")}`;
  }

  // 1 + N days
  return `${trialDays} ${t("duration.xDays")}`;
};

export const getPlanDetails = (plan: InternalStripe.Plan) => {
  switch (plan.interval) {
    case "month":
      return {
        title: "payment:plan.intervals.monthly",
        perks: [
          "payment:plan.perks.unlimitedAccess",
          "payment:plan.perks.cancelAnytime",
        ],
      };

    case "year":
      return {
        title: "payment:plan.intervals.yearly",
        perks: [
          "payment:plan.perks.unlimitedAccess",
          "payment:plan.perks.yearlyPlan",
        ],
      };
  }

  return null;
};
